import { LOCAL_STORAGE_KEY } from 'constants';

export const clearLocalStorage = () => {
  localStorage.setItem(`${LOCAL_STORAGE_KEY}access-token`, '');
  localStorage.setItem(`${LOCAL_STORAGE_KEY}chosen-league`, '');
  localStorage.setItem(`${LOCAL_STORAGE_KEY}chosen-team`, '');
};
